import { FC } from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';
import Tooltip from '../tooltip/tooltip.component';
import { COLORS } from '../../consts/colors';
import { STRING_KEYS } from '../../language/keys';
import { InfoTooltipProps } from './info-tooltip.d';
import {
  InfoTooltipContent,
  LearnMoreContainer,
  LearnMoreText,
  TooltipContainer,
  TooltipText,
  TooltipTitle,
  TooltipTitleIcon,
  RectangleIconBg,
  TooltipLeftColumn,
  TooltipRightColumn,
} from './info-tooltip.styled';

const InfoTooltip: FC<InfoTooltipProps> = ({
  title,
  content,
  titleIcon,
  placement = 'top-end',
  children,
  variant = 'icon',
}: InfoTooltipProps) => {
  const { t: translate } = useTranslation();
  const tooltipContent = (
    <InfoTooltipContent>
      <TooltipLeftColumn>
        {titleIcon && (
          <TooltipTitleIcon>
            <RectangleIconBg>{titleIcon}</RectangleIconBg>
          </TooltipTitleIcon>
        )}
      </TooltipLeftColumn>
      <TooltipRightColumn>
        <TooltipTitle>{title}</TooltipTitle>
        <TooltipText>{content}</TooltipText>
      </TooltipRightColumn>
    </InfoTooltipContent>
  );

  return (
    <Tooltip
      content={ tooltipContent }
      placement={ placement }
      showTooltipDelay={ 0 }
      hideTooltipDelay={ 100 }
      transitionDuration={ 200 }
      customTooltipStyle={ {
        background: COLORS.WHITE1,
        color: COLORS.DARK_BLUE,
        padding: 0,
        borderRadius: '20px',
        boxShadow: '0 6px 20px 0 rgba(0, 0, 0, 0.15)',
        maxWidth: '414px',
      } }
    >
      {children ? (
        <TooltipContainer>{children}</TooltipContainer>
      ) : (
        <TooltipContainer>
          {variant === 'learn-more' ? (
            <LearnMoreContainer>
              <LearnMoreText>{translate(STRING_KEYS.INFO_TOOLTIP.LEARN_MORE)}</LearnMoreText>
              <HelpOutlineIcon sx={ { opacity: 0.6, color: COLORS.DARK_PURPLE, fontSize: 16 } } />
            </LearnMoreContainer>
          ) : (
            <HelpOutlineIcon sx={ { opacity: 0.6, color: COLORS.DARK_PURPLE, fontSize: 16 } } />
          )}
        </TooltipContainer>
      )}
    </Tooltip>
  );
};

export default InfoTooltip;
